import "../assets/index-a9e4fe04.css";
import { n } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const r = {
  props: {
    appName: {
      type: String,
      required: !0
    }
  }
};
var s = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "content", class: `app-${e.appName.toLowerCase()}`, attrs: { id: "content-vue" } }, [e._t("default")], 2);
}, _ = [], a = /* @__PURE__ */ n(
  r,
  s,
  _,
  !1,
  null,
  "eb1078f7",
  null,
  null
);
const l = a.exports;
export {
  l as default
};
